import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackingBaseMobilePhoneEvent } from '../../../actions/tracking';
import { CALL_TRACKING_TIMEOUT } from '../../../constants/timeouts';
import { selectPhone } from '../../../selectors/newbuilding';
import { TThunkDispatch } from '../../../types/redux';
import { useWindowActiveRef } from './useWindowActiveRef';

interface IPhoneButton {
  handlePhoneCall(): void;
  handlePhoneShow(): void;
  phone: string;
}

export const usePhoneButton = (): IPhoneButton => {
  const phone = useSelector(selectPhone);
  const dispatch: TThunkDispatch = useDispatch();
  const isWindowActiveRef = useWindowActiveRef();

  const handlePhoneShow = React.useCallback(() => {
    dispatch(trackingBaseMobilePhoneEvent('Open_buildingprogress_JK'));
  }, [dispatch]);

  const handlePhoneCall = React.useCallback(() => {
    setTimeout(() => {
      if (!isWindowActiveRef.current) {
        dispatch(trackingBaseMobilePhoneEvent('Call'));
      }
    }, CALL_TRACKING_TIMEOUT);
  }, [dispatch, isWindowActiveRef]);

  return {
    handlePhoneCall,
    handlePhoneShow,
    phone,
  };
};
